export default __webpack_public_path__ + "static/media/fad-slider-round-2.f420c956.svg";